import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-rule-editor',
  template: `<p>
  filter-rule-editor works!
</p>
`,
  styles: [``]
})
export class FilterRuleEditorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
